<template>
    <div v-show="visible && loaded && cards.length > 0" class="semler-swiper">
        <p class="semler-swiper__headline">Semler Mobility <em>Swipe</em></p>
        <img class="semler-swiper__close" src="/assets/images/semlerSwiper/Luk-Swiper_icon_X.svg" height="40" width="40"
            alt="" role="button" @click="handleClose(false)" tabindex="0" />
        <div class="semler-swiper__stack swiper" ref="semlerSwiper">
            <div class="semler-swiper__wrapper swiper-wrapper">
                <li v-for="(card, index) in cards" :key="card.id" class="semler-swiper__card swiper-slide">
                    <SwiperVehicleCard :vehicle="card" :vehicleNodeId="vehicleNodeId" />
                    <a class="vehicle-card__extra-link" @click="showVehicle = true">{{
                        dictionary.semlerSwiperShowVehicleLabel }}</a>
                    <div class="swiper-tinder-label swiper-tinder-label-yes">{{ dictionary.semlerSwiperYesStamp }}</div>
                    <div class="swiper-tinder-label swiper-tinder-label-no">{{ dictionary.semlerSwiperNoStamp }}</div>
                </li>
                <li v-show="showEndCard" class="swiper-slide">
                    <div class="semler-swiper__dialog-wrap">
                        <p class="semler-swiper__dialog-headline">{{ dictionary.semlerSwiperNoMoreVehiclesHeadline }}
                        </p>
                        <p>{{ dictionary.semlerSwiperNoMoreVehiclesText }}</p>
                        <Button class="p-button-primary" @click="handleFilterToggle">{{
                            dictionary.semlerSwiperNoMoreVehiclesFilterLabel }}</Button>
                        <Button class="p-button-secondary" @click="handleClose(true)">{{
                            dictionary.semlerSwiperNoMoreVehiclesCloseLabel }}</Button>
                    </div>
                </li>
            </div>
        </div>
        <div class="semler-swiper__navigation">
            <img src="/assets/images/semlerSwiper/Icon_Back.svg" alt="" height="40" width="40" role="button"
                aria-label="Spol tilbage" @click="handleRewind" tabindex="0" />
            <div class="semler-swiper__navigation-button-wrap">
                <div v-if="showHelp" class=semler-swiper__navigation-button-tooltip>
                    {{ dictionary.semlerSwiperDislikeTooltip }}
                </div>
                <img src="/assets/images/semlerSwiper/Icon_Dislike.svg" alt="" height="57" width="57" role="button"
                    aria-label="Synes ikke godt om bil" @click="swiper.tinder.no()" tabindex="0" />
            </div>

            <div class="semler-swiper__profile" role="button" tabindex="0" aria-label="Vis likede biler"
                @click="handleFavoritesClick">
                <div class="semler-swiper__favorites-count">{{ favoritesCount }}</div>
                <img src="/assets/images/semlerSwiper/Icon_Car.svg" alt="" role="presentation" height="45" width="45" />
            </div>

            <div class="semler-swiper__navigation-button-wrap">
                <div v-if="showHelp" class=semler-swiper__navigation-button-tooltip>
                    {{ dictionary.semlerSwiperLikeTooltip }}
                </div>
                <img src="/assets/images/semlerSwiper/Icon_Like.svg" alt="" height="57" width="57" role="button"
                    aria-label="Synes godt om bil" @click="swiper.tinder.yes()" tabindex="0" />
            </div>


            <img src="/assets/images/semlerSwiper/Icon_Filter.svg" alt="" height="40" width="40" role="button"
                aria-label="Åben filter" @click="handleFilterToggle" tabindex="0" />
        </div>
        <UserSignupPopup :visible="showPopup" @closePopup="showPopup = false"></UserSignupPopup>
        <SwiperSavePrompt :visible="showSavePrompt" @closePopup="handleCloseSavePrompt" :dictionary="dictionary">
        </SwiperSavePrompt>
        <Dialog class="semler-swiper__dialog semler-dialog" v-model:visible="showIntroduction"
            @show="handleWelcomeDialogShown" :dismissableMask="true" :draggable="false" modal :showHeader="false"
            style="width:330px;border-radius: 15px" :pt="{
                root: 'border-none'
            }">
            <template #default="{ closeCallback }">
                <div class="semler-swiper__dialog-wrap" :class="{'semler-swiper__dialog-wrap--valentine': isValentine }">
                    <small>{{ dictionary.semlerSwiperWelcomePreHeadline }}</small>
                    <div v-if="isValentine" id="semlerWelcomeAnimation" data-lottie-json="/assets/animations/swiperLogoValentine.json">
                    </div>
                    <div v-else id="semlerWelcomeAnimation" data-lottie-json="/assets/animations/swiperLogoEvergreen.json"></div>
                    <p class="semler-swiper__dialog-text">{{ dictionary.semlerSwiperWelcomeText }}</p>
                    <Button class="p-button-primary p-button-sm"  :class="{'p-button-primary--valentine ': isValentine }"
                        @click="handleCloseWelcomeScreen">{{
                            dictionary.semlerSwiperWelcomeBeginLabel }}</Button>
                </div>
            </template>
        </Dialog>

        <Dialog class="semler-swiper__dialog semler-dialog" v-model:visible="showFavorites" :dismissableMask="true"
            :draggable="false" modal :showHeader="false" style="width:330px;border-radius: 15px" :pt="{
                root: 'border-none'
            }">
            <template #default="{ closeCallback }">
                <div class="semler-swiper__dialog-wrap semler-swiper__dialog-wrap--slim"
                    style="background-color:#f0f5fa">
                    <div class="semler-swiper__dialog-header">
                        <p class="semler-swiper__dialog-headline">{{ dictionary.semlerSwiperFavoritesListHeadline }}</p>
                        <img src="/assets/images/semlerSwiper/Luk-Swiper_icon_X.svg" height="24" width="24" alt=""
                            role="button" @click="showFavorites = false" tabindex="0" />
                    </div>
                    <div class="semler-swiper__favorites-dialog-list-wrap">
                        <ul v-if="favorites.length" class="semler-swiper__favorites-dialog-list">
                            <li class="semler-swiper__favorites-dialog-list__item" v-for="favorite in favorites"
                                :key="favorite">
                                <div class="semler-swiper__favorites-dialog-list__item__vehicle">
                                    <a class="semler-swiper__favorites-dialog-list__item__image" :href="favorite.url"
                                        target="_blank" title="Gå til bilen i nyt vindue">
                                        <img :src="favorite.imageUrl + '?width=82'" width="82" loading="lazy" alt="" />
                                    </a>
                                    <div class="semler-swiper__favorites-dialog-list__item__info">
                                        <p class="semler-swiper__favorites-dialog-list__item__title">{{
                                            favorite.modelName }}</p>

                                        <p class="semler-swiper__favorites-dialog-list__item__trim">{{
                                            favorite.modelTrim
                                            }}</p>
                                        <p class="semler-swiper__favorites-dialog-list__item__price"
                                            v-if="favorite.price > 0">{{
                                                favorite.price.toLocaleString(culture) }}
                                            kr.
                                        </p>
                                        <p class="semler-swiper__favorites-dialog-list__item__price"
                                            v-else-if="favorite.leasingPrice > 0">{{
                                                favorite.leasingPrice.toLocaleString(culture) }} kr./mdr. <br />{{
                                                favorite.leasingType ==
                                                    "Privatleasing" ? dictionary.vehicleCommonIncludingVat :
                                                    dictionary.vehicleCommonExcludingVat }}
                                        </p>
                                        <p>Årgang: {{ favorite.modelYear }}</p>
                                    </div>
                                </div>
                                <Button @click="handleRemoveLike(favorite.id)" icon="pi pi-trash" text rounded></Button>
                            </li>
                        </ul>
                        <p v-else>Du har endnu ikke liked nogle biler</p>
                    </div>
                    <div class="semler-swiper__favorites-dialog-navigation">
                        <Button class="p-button-primary p-button-sm"
                            @click="() => { showFavorites = false; showSavePrompt = true; }">{{ dictionary.semlerSwiperFavoritesListSaveButtonLabel }}</Button>
                    </div>
                </div>
            </template>
        </Dialog>

        <Dialog class="semler-swiper__vehicle-embed semler-dialog" v-model:visible="showVehicle" :dismissableMask="true"
            :draggable="false" modal :showHeader="false" :style="{ width: '95%', maxWidth: '1120px', height: '95vh' }">
            <template #default="{ closeCallback }">
                <iframe :src="`${cards[swiper.activeIndex].url}?minimal=true`"
                    style="width:100%;height:calc(100% - 65px)"></iframe>
                <div style="height:60px;display:flex;align-items: center;justify-content: space-between">

                    <Button class="p-button-sm" text :label="dictionary.semlerSwiperHideVehicleLabel"
                        @click="showVehicle = false"></Button>
                    <Button class="p-button-sm" text :label="dictionary.semlerSwiperGoToVehicleLabel"
                        @click="goToVehicle"></Button>
                </div>
            </template>

        </Dialog>
    </div>
</template>
<script>

import SwiperVehicleCard from './swiperVehicleCard.vue';
import Swiper from 'swiper';
import EffectTinder from './../../vendor/swiperPlugins/effect-tinder.esm.js';
import Dialog from 'primevue/dialog';
import VueHelpers from './../vueHelpers.js';
import UserSignupPopup from './userSignupPopup.vue';
import Button from 'primevue/button';
import SwiperSavePrompt from './swiperSavePrompt.vue';
import lottie from "lottie-web";

const skipWelcomeScreenCacheKey = "skipWelcomeScreen";

export default {
    name: "semlerSwiper",
    props: ['vehicles', 'visible', 'vehicleNodeId', 'appendVehicles', 'skipOnboarding', 'isUserLoggedIn', 'favoritesPageUrl'],
    components: {
        SwiperVehicleCard,
        Dialog,
        UserSignupPopup,
        SwiperSavePrompt,
        Button
    },
    data() {
        return {
            culture: "da-DK",
            dictionary: [],
            history: [],
            likes: [],
            dislikes: [],
            swiper: null,
            loaded: false,
            showWelcome: false,
            showPopup: false,
            showFavorites: false,
            showEndCard: false,
            showSavePrompt: false,
            favorites: [],
            cards: [],
            showTooltips: true,
            initialLike: null,
            showVehicle: false

        };
    },
    created() {
        const vm = this;
        vm.culture = document.querySelector("html").getAttribute("lang");
        vm.initialLike = localStorage.getItem(VueHelpers.initSemlerSwiperKey);

        fetch('/umbraco/api/resourcesApi/GetSemlerSwiperDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });

        if (vm.visible) {
            vm.initialize();
        }
    },
    watch: {
        vehicles: {
            handler(newVal, oldVal) {
                const vm = this;
                if (vm.loaded) {
                    if (vm.vehicles.length == 0 && vm.visible) {
                        vm.showEndCard = true;
                    } else {
                        vm.showEndCard = false;
                        if (vm.appendVehicles) {
                            vm.cards.push(...VueHelpers.shuffle(vm.vehicles.filter(x => !vm.favorites.some(y => y.id == x.id) && x.hasImageUrl == true && x.hasMultipleImagesAvailableInFullSet == true)));
                        } else {
                            vm.cards = VueHelpers.shuffle(vm.vehicles.filter(x => !vm.favorites.some(y => y.id == x.id) && x.hasImageUrl == true && x.hasMultipleImagesAvailableInFullSet == true));
                        }
                        vm.cards = vm.cards.filter(x => typeof (x) != "undefined"); //Sorting any faulty, undefined cards avay
                        vm.swiper.update();
                    }
                }
            }
        },
        visible: {
            handler(newVal, oldVal) {
                const vm = this;
                if (oldVal == false && newVal == true) {
                    //Init Semler Swipe as it was hidden and is now visible
                    vm.initialize();
                } else {
                    //Destroy the slider and reset various other properties as Semler Swipe is closed
                    if (vm.swiper) {
                        vm.swiper.destroy();
                    }
                    vm.showWelcome = false;
                    vm.showEndCard = false;
                }
            }
        },
        favorites: {
            handler(newVal, oldVal) {
                console.log("Touching favorites");

                localStorage.setItem(VueHelpers.favoritesCacheKey, JSON.stringify(newVal));
            },
            deep: true
        }
    },
    methods: {
        initialize() {
            const vm = this;
            document.body.classList.add('swiper-active');
            const skipWelcomeScreen = sessionStorage.getItem(skipWelcomeScreenCacheKey);
            if (skipWelcomeScreen) {
                this.showWelcome = false;
            } else {
                vm.showWelcome = true;
            }
            vm.showTooltips = true;

            //Get favorites saved on localhost
            const savedFavorites = localStorage.getItem(VueHelpers.favoritesCacheKey);
            if (savedFavorites) {
                vm.favorites = JSON.parse(savedFavorites);
            }

            //If the user is logged in, merge their favorites with the ones in localhost
            fetch("/umbraco/api/favoritesApi/GetFavorites").then((response) => {
                if (response.status == 200) {

                    return response;
                }
                const error = new Error("");
                error.status = response.status;
                throw error;
            }).then(response => response.json())
                .then(data => {
                    // vm.favorites = data.items.map(x => x.vehicle.id);
                    const combinedFavorites = new Map([...vm.favorites, ...data.items.map(x => x.vehicle)].map(x => [x.id, x]));
                    vm.favorites = Array.from(combinedFavorites.values());
                })
                .catch((error) => {
                    if (error.status != 401) {
                        console.log(error);
                    }
                }).finally(() => {
                    vm.cards = VueHelpers.shuffle(vm.vehicles.filter(x => !vm.favorites.some(y => y.id == x.id) && x.hasImageUrl == true && x.hasMultipleImagesAvailableInFullSet == true));

                    //If we supply an id for a car for showing first, get it here and move that card to the start of the cards array
                    if (vm.initialLike) {
                        const index = vm.cards.findIndex(x => x.id == vm.initialLike);
                        const vehicle = vm.cards.slice(index, index + 1);
                        vm.cards.unshift(vehicle[0]);
                        localStorage.removeItem(VueHelpers.initSemlerSwiperKey);
                    }

                    vm.cards = vm.cards.filter(x => typeof (x) != "undefined"); //Sorting any faulty, undefined cards avay

                    //Init swiper
                    vm.swiper = new Swiper(vm.$refs.semlerSwiper, {
                        modules: [EffectTinder],
                        effect: 'tinder',
                        autoHeight: true,
                        grabCursor: true,
                        observer: true,
                        observeParents: true,
                        observeSlideChildren: true,
                        oneWayMovement: true,
                        on: {
                            afterInit: () => {
                                vm.loaded = true;
                                window.swiper = vm.swiper;
                                window.scrollTo(0, 1);
                            },
                            tinderSwipe: (swiper, direction) => {
                                vm.showTooltips = false;
                                if (direction == 'right') {
                                    vm.handleLike();
                                } else if (direction == 'left') {
                                    vm.handleDislike();
                                }
                                if (vm.swiper.isEnd) {
                                    vm.$emit("loadMoreVehicles");
                                }
                            }
                        }
                    });

                    vm.loaded = true;
                });
        },
        handleFavoritesClick() {
            const vm = this;

            vm.showFavorites = true;

            // if (vm.isUserLoggedIn) {
            //     window.open(vm.favoritesPageUrl, '_blank');
            // } else {
            //     localStorage.setItem(VueHelpers.loginRedirectUrlKey, this.favoritesPageUrl);
            //     vm.showPopup = true;

        },
        goToVehicle() {
            const activeCar = this.cards[this.swiper.activeIndex];
            window.dataLayer.push({
                'event': 'swiper_go_to_car',
                'carBrand': activeCar.brand,
                'carModel': activeCar.shortModelName
            });

            window.open(activeCar.url, '_blank');
        },
        handleRewind() {
            const vm = this;
            let slideIndex = vm.swiper.activeIndex - 1;
            if (slideIndex < 0) { slideIndex = 0; }
            const vehicleId = vm.cards[slideIndex].id;
            const favoriteIndex = vm.favorites.findIndex(x => x.id == vehicleId);
            if (favoriteIndex > -1) {
                fetch('/umbraco/api/favoritesApi/ToggleFavorite', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify({ vehicleId: vehicleId, vehicleNodeId: vm.vehicleNodeId, action: 'remove' }),
                }).then((response) => {
                    if (response.status == 404) {
                        vm.favorites.splice(favoriteIndex, 1);
                    }
                    return response;
                }).catch((error) => {
                    console.log(error);
                });
            }

            vm.swiper.activeIndex = slideIndex;
        },
        handleLike() {
            const vm = this;
            let slideIndex = vm.swiper.activeIndex - 1; //We subtract one because we are already moved on to the next slide in the "activeIndex"
            if (slideIndex < 0) { slideIndex = 0; };
            const vehicle = vm.cards[slideIndex];
            if (vm.isUserLoggedIn) {
                fetch('/umbraco/api/favoritesApi/ToggleFavorite', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify({ vehicleId: vehicle.id, vehicleNodeId: vm.vehicleNodeId }),
                }).then((response) => {
                    if (response.status == 200) {
                        vm.favorites.push(vehicle)
                        return response;
                    } else {
                        vm.favorites.splice(vm.favorites.findIndex(x => x.id == vehicle.id), 1);
                    }

                });
            } else {
                vm.favorites.push(vehicle);
                localStorage.setItem(VueHelpers.initSemlerSwiperKey, vehicle.id);
            }

            window.dataLayer.push({
                'event': 'swiper_like_car',
                'carId': vehicle.id,
                'carBrand': vehicle.brand,
                'carModel': vehicle.shortModelName
            })
        },
        handleRemoveLike(vehicleId) {
            console.log(vehicleId);
            const vm = this;
            if (vm.isUserLoggedIn) {
                //The user is logged in, so the vehicle is favorite, so we can just call toggle and it should be disliked
                fetch('/umbraco/api/favoritesApi/ToggleFavorite', {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json",
                        "RequestVerificationToken": VueHelpers.getAntiForgeryToken()
                    },
                    body: JSON.stringify({ vehicleId: vehicleId, vehicleNodeId: vm.vehicleNodeId }),
                });
            }
            vm.favorites.splice(vm.favorites.findIndex(x => x.id == vehicleId), 1);
        },
        handleDislike() {
            const vehicle = this.cards[this.swiper.activeIndex];
            if (vehicle) {
                this.dislikes.push(this.cards[this.swiper.activeIndex].id);
                window.dataLayer.push({
                    'event': 'swiper_dislike_car',
                    'carId': vehicle.id,
                    'carBrand': vehicle.brand,
                    'carModel': vehicle.shortModelName
                })
            }
        },
        handleFilterToggle() {
            this.showTooltips = false;
            this.$emit('openFilter');
        },
        handleClose(showSavePrompt = true) {
            if (!this.isUserLoggedIn && showSavePrompt) {
                this.showSavePrompt = true;
                return;
            }
            localStorage.removeItem(VueHelpers.initSemlerSwiperKey);
            localStorage.removeItem(VueHelpers.loginRedirectUrlKey);
            document.body.classList.remove('swiper-active');
            this.showFavorites = false;
            this.showSavePrompt = false;
            this.showVehicle = false;
            this.$emit('closeSwiper');
        },
        handleCloseSavePrompt(closeSwiper = false) {
            this.showSavePrompt = false;
            if (closeSwiper) {
                this.handleClose(false);
            }
        },
        handleCloseWelcomeScreen() {
            this.showWelcome = false;
            sessionStorage.setItem(skipWelcomeScreenCacheKey, true);
        },
        handleWelcomeDialogShown() {
            const element = document.getElementById('semlerWelcomeAnimation');
            const animationPath = element.dataset.lottieJson;
            const loop = true; // Default loop value
            const delay = 0; // Default delay value

            // Load animation
            const animation = lottie.loadAnimation({
                container: element,
                renderer: 'svg',
                loop: loop,
                autoplay: true,
                path: animationPath
            });

            element.lottieInstance = animation;
        }
    },
    computed: {
        favoritesCount() {
            return this.favorites.length;
        },
        showIntroduction() {
            return this.showWelcome && !this.skipOnboarding;
        },
        showHelp() {
            return this.showTooltips && !this.skipOnboarding;
        },
        isValentine() {
            const targetDate = new Date(2025, 1, 15, 0, 0, 0); // February 15, 2025
            const currentDate = new Date();
            return currentDate < targetDate;
        }
    }
};
</script>
